import { Scene } from "@babylonjs/core"

const isMainScene =(scene: Scene)=>{
    return scene && scene.metadata && scene.metadata.isMain
}

export default isMainScene;